export const getDocumentColumns = (translate, isSubUser) => {
  return isSubUser
    ? [
        {
          key: "documentNumber",
          text: translate("DocumentNumber"),
        },
        {
          key: "ebid",
          text: "EBID",
        },
        {
          key: "flows",
          text: translate("Flows"),
        },
        {
          key: "flowName",
          text: translate("flowName"),
        },
        {
          key: "sender",
          text: translate("Sender"),
        },
        {
          key: "senderName",
          text: translate("Sender Name"),
        },
        {
          key: "receiver",
          text: translate("Receiver"),
        },
        {
          key: "receiverName",
          text: translate("Receiver Name"),
        },
        {
          key: "channels",
          text: translate("Channels"),
        },
        {
          key: "arrivalTime",
          text: translate("ArrivalTime"),
        },
        {
          key: "lastUpdate",
          text: translate("LastUpdate"),
        },
        {
          key: "status",
          text: translate("Status"),
        },
      ]
    : [
        {
          key: "customer",
          text: translate("Customer"),
        },
        {
          key: "platform",
          text: translate("Platform"),
        },
        {
          key: "documentNumber",
          text: translate("DocumentNumber"),
        },
        {
          key: "docid",
          text: translate("DocumentId"),
        },
        {
          key: "ebid",
          text: "EBID",
        },
        {
          key: "flows",
          text: translate("Flows"),
        },
        {
          key: "flowName",
          text: translate("flowName"),
        },
        {
          key: "sender",
          text: translate("Sender"),
        },
        {
          key: "senderName",
          text: translate("Sender Name"),
        },
        {
          key: "receiver",
          text: translate("Receiver"),
        },
        {
          key: "receiverName",
          text: translate("Receiver Name"),
        },
        {
          key: "channels",
          text: translate("Channels"),
        },
        {
          key: "arrivalTime",
          text: translate("ArrivalTime"),
        },
        {
          key: "lastUpdate",
          text: translate("LastUpdate"),
        },
        {
          key: "status",
          text: translate("Status"),
        },
      ];
};
